import styles from "@components/MarketWorking/MyTeam/MyDiaryList.module.css";
import { useSelector } from "react-redux";
import Message from "@features/shared/components/Message";
import { format } from "date-fns";
import Modal from "react-bootstrap/Modal";

const MyDiaryList = ({ name, isOpen, setIsOpen }) => {
  const visitData = useSelector((state) =>
    name === "wssPage"
      ? state?.myDiaryDetails?.mydiaryWSSDetails
      : state?.myDiaryDetails?.mydiaryDealerDetails
  );

  return (
    <Modal
      show={isOpen}
      onHide={() => setIsOpen(false)}
      size="xl"
      centered
      aria-labelledby="mydiarylist-modal-title"
      dialogClassName={styles.mydiaryListModalDialog}
      contentClassName={styles.mydiaryListModalContent}
      backdrop={false}
    >
      <Modal.Header closeButton style={{ borderBottom: "1px solid #eee" }}>
        <Modal.Title id="mydiarylist-modal-title" style={{ color: "#3901FF" }}>
          Previous Observation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className={styles.mydiaryListModalBody}
        style={{
          flex: 1,
          minHeight: 0,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          padding: 0,
        }}
      >
        <div
          className={styles.mydiaryList}
          style={{
            flex: 1,
            minHeight: 0,
            height: "100%",
          }}
        >
          <div className={styles.mydiaryList__mainBox}>
            <div className="row m-0 p-0">
              <div
                className={` ${
                  visitData?.length > 0 ? styles.mydiaryList__rightBox : "mt-2"
                }`}
                style={{ height: "100%" }}
              >
                <div className={styles.titleBox}>
                  <div className={`${styles.mydiaryList_title}`}>
                    {" "}
                    Observation history
                  </div>
                  <div>
                    <div className={styles.mydiaryList__titleInnerBox}>
                      <div className={styles.mydiaryList__titleBoxValue}>
                        {visitData?.length} Observations
                      </div>
                    </div>
                  </div>
                </div>
                {visitData?.length > 0 ? (
                  <div className={styles.mydiaryList__headerBox}>
                    <div
                      className={
                        styles.mydiaryList__headerValue + " " + styles.observation
                      }
                    >
                      Observation
                    </div>
                    <div
                      className={styles.mydiaryList__headerValue + " " + styles.date}
                    >
                      Date
                    </div>
                  </div>
                ) : (
                  <Message
                    message={"No previous observations"}
                    className="mydiaryList__OuterDiv"
                  />
                )}

                <div className={styles.mydiaryList__plansBox}>
                  {visitData &&
                    visitData.map((detials, idx) => (
                      <div className={styles.mydiaryList__despBox} key={idx}>
                        <div
                          className={
                            styles.mydiaryList__despBoxValue + " " + styles.observation
                          }
                        >
                          {detials?.Observations__c}
                        </div>
                        <div
                          className={
                            styles.mydiaryList__despBoxValue + " " + styles.date
                          }
                        >
                          {format(
                            new Date(detials?.CreatedDate),
                            "yyyy-MM-dd HH:mm:ss"
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MyDiaryList;
